var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.205 3.356c-1.354.366-2.412 1.38-2.793 2.678-.822-.3-1.414-1.05-1.414-1.943 0-1.153.978-2.091 2.18-2.091a2.17 2.17 0 0 1 2.027 1.356zm1.333 1.169c.856.311 1.472 1.092 1.472 2.021 0 1.2-1.018 2.176-2.27 2.176a2.26 2.26 0 0 1-2.11-1.41 2.086 2.086 0 0 1-.16-.766c0-.06.03-.11.035-.169.09-1.058.955-1.888 2.06-1.973.06-.005.113-.034.175-.034.281 0 .548.063.798.155zM21 11.86c0 1.284-.669 1.985-1.405 2.34.031.227.052.456.052.69 0 1.542-.732 2.944-1.926 4.006l.764.74c.538.52.538 1.373 0 1.895l-.082.078a1.417 1.417 0 0 1-1.955 0l-1.273-1.231a9.017 9.017 0 0 1-3.017.512 9.025 9.025 0 0 1-3.019-.512l-1.272 1.231a1.419 1.419 0 0 1-1.956 0l-.082-.078a1.315 1.315 0 0 1 0-1.894l.764-.741c-.731-.652-1.29-1.429-1.61-2.292h-1.3a.673.673 0 0 1-.683-.66v-2.109c0-.362.307-.66.683-.66h1.3a5.692 5.692 0 0 1 1.345-2.048l-.821-1.584a.576.576 0 0 1 .395-.821 3.224 3.224 0 0 1 2.912.805 9.014 9.014 0 0 1 3.344-.636c3.368 0 6.216 1.78 7.159 4.231.319-.226.586-.603.586-1.262a.54.54 0 0 1 .55-.53c.303 0 .547.237.547.53zM7.826 13.8c.561 0 1.016-.44 1.016-.984s-.455-.985-1.016-.985c-.562 0-1.017.441-1.017.985 0 .543.455.984 1.017.984z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworth);
export default __webpack_public_path__ + "static/media/networth.ac17a953386ddb794baed5f762575345.svg";
export { ForwardRef as ReactComponent };